<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"

    :headers="headers"
    item-key="_id"
  >
    <template v-slot:item.annualFee="{ item }">
      {{ formatPercentage(item.annualFee) }}
    </template>

    <template v-slot:item.operationDate="{ item }">
      {{ formatDate(item.operationDate) }}
    </template>

    <template v-slot:item.loanDueDate="{ item }">
      {{ formatDate(item.loanDueDate) }}
    </template>

    <template v-slot:item.quantity="{ item }">
      <span :class="{ 'error--text': item.quantity < 0 }">
        {{ formatNumber(item.quantity) }}
      </span>
    </template>

    <template v-slot:item.refPrice="{ item }">
      <span :class="{ 'error--text': item.refPrice < 0 }">
        {{ formatCurrency(item.refPrice) }}
      </span>
    </template>

    <template v-slot:item.accruedFees="{ item }">
      <span :class="{ 'error--text': item.accruedFees < 0 }">
        {{ formatCurrency(item.accruedFees) }}
      </span>
    </template>

    <template v-slot:item.percValue="{ item }">
      <span :class="{ 'error--text': item.percValue < 0 }">
        {{ formatPercentage(item.percValue) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import {
  formatCurrency,
  formatDate,
  formatNumber,
  formatPercentage,
} from '@/utils/format-utils';

export default {
  name: 'HoldingSharesTable',

  inheritAttrs: false,

  data: () => ({
    headers: [
      {
        value: 'ticker',
        text: 'Ativo',
      },

      {
        value: 'book',
        text: 'Book',
      },

      {
        value: 'side',
        text: 'Ponta',
      },

      {
        value: 'annualFee',
        text: 'Taxa',
        align: 'end',
      },

      {
        value: 'operationDate',
        text: 'Data operação',
      },

      {
        value: 'loanDueDate',
        text: 'Vencimento',
      },

      {
        value: 'quantity',
        text: 'Quantidade',
        align: 'end',
      },

      {
        value: 'refPrice',
        text: 'PU',
        align: 'end',
      },

      {
        value: 'accruedFees',
        text: 'Taxa acruada',
        align: 'end',
      },

      {
        value: 'percValue',
        text: '%PL',
        align: 'end',
      },
    ],
  }),

  methods: {
    formatCurrency,
    formatDate,
    formatNumber,
    formatPercentage,
    formatPerformance: (val) => formatPercentage(val, {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    }),
  },
};
</script>
